import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import clsx from 'clsx';
import { useCallback, useMemo } from 'react';
import { WebLink } from '@/components/functional/Link/WebLink';
export const BaseTab = (props) => {
    const { activeValue = undefined, children, classNames = {}, disabled = false, onChange: propOnChange = undefined, target = '_self', to, value, } = props;
    const { button: buttonClass, tab: tabClass } = classNames;
    // active 判定
    const active = activeValue === value;
    // 装飾用のclassName
    const styleClassName = useMemo(() => clsx('flex items-center justify-center', 'w-full h-full', buttonClass === null || buttonClass === void 0 ? void 0 : buttonClass.normal, active
        ? ['hover:cursor-default', buttonClass === null || buttonClass === void 0 ? void 0 : buttonClass.active]
        : ['hover:cursor-pointer', buttonClass === null || buttonClass === void 0 ? void 0 : buttonClass.inactive], disabled && (buttonClass === null || buttonClass === void 0 ? void 0 : buttonClass.disabled)), [active, buttonClass, disabled]);
    const onChange = useCallback(() => {
        propOnChange === null || propOnChange === void 0 ? void 0 : propOnChange(value);
    }, [propOnChange, value]);
    return (_jsx("div", Object.assign({ className: clsx(tabClass === null || tabClass === void 0 ? void 0 : tabClass.normal, active ? tabClass === null || tabClass === void 0 ? void 0 : tabClass.active : tabClass === null || tabClass === void 0 ? void 0 : tabClass.inactive, disabled && (tabClass === null || tabClass === void 0 ? void 0 : tabClass.disabled)) }, { children: to ? (
        /**
         * リンク指定されている場合リンクコンポーネントを使用
         * DynamicLink の noLinkElement={'button'}だと、valueの設定ができないので... if-elseで制御しています
         */
        _jsx(WebLink, Object.assign({ className: styleClassName, target: target, to: to }, { children: children }))) : (
        // リンク指定されていない場合、button  + valueで制御する
        _jsx("button", Object.assign({ className: styleClassName, disabled: disabled, onClick: onChange, type: 'button', value: value }, { children: children }))) })));
};
